import {isUndefined} from 'lodash';
import numeral from 'numeral';

const Zero = '0';
const ZeroTwoPrecision = '.00';

export const Integer        = number => numeral(Math.trunc(parseFloat(number))).format('0,0');
export const IntegerRounded = number => numeral(parseFloat(number)).format('0,0');

// NOTE: ParseInt accepts 2 arguments.
// Not supplying the second 1 will result
// to the linter complaining.
// Now, 10 is the base value of the mathematical
// numerical system that we are using.
// See. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/parseInt
export const parseIntUtil = (str) => {
  return parseInt(str, 10)
}

export const Decimal = ({ number, precision = 2 }) => {
  if (isUndefined(number)) return;
  if (Number.isInteger(parseFloat(number))) return ZeroTwoPrecision;

  const extractedDecimal            = decimalFrom(splitParts(numberAsString(number)));
  const decimalWithAppliedPrecision = decimalInPrecision(extractedDecimal, precision);

  if (isOnlyOnePlace(decimalWithAppliedPrecision)) return appendZero(decimalWithAppliedPrecision);

  return `.${decimalWithAppliedPrecision}`;
};
export const DecimalRounded = ({number = 0, precision = 2}) => {
  return numeral(parseFloat(number)).format(`.${Zero.repeat(precision)}`);
}

export const RealNumber = ({number = 0, precision = 2}) => {
  const parts   = splitParts(numberAsString(number));
  const integer = integerFrom(parts);
  const decimalWithAppliedPrecision = decimalInPrecision(decimalFrom(parts), precision);
  const realNumber = `${integer}.${decimalWithAppliedPrecision}`;

  return numeral(realNumber).format(`0,0.${Zero.repeat(precision)}`);
};

export const RealNumberRounded = ({number = 0, precision = 2}) => {
  return numeral(parseFloat(number)).format(`0,0.${Zero.repeat(precision)}`);
};

const numberAsString     = number => parseFloat(number).toString();
const splitParts         = number => number.split('.');
const integerFrom        = number => number[0];
const decimalFrom        = number => {
  if (isUndefined(number[1])) return '00';
  return number[1];
};
const decimalInPrecision = (decimal, precision) => decimal.substring(0, precision);
const isOnlyOnePlace     = decimal  => decimal.length === 1;
const appendZero         = decimal => `.${decimal}0`;



// WEBPACK FOOTER //
// ./src/utils/NumeralParts.js